<div class="row addresses">
  <div class="row-item">
    <p class="heading">Lieferadresse</p>
    <mat-list>
      <mat-list-item>
        <span matListItemTitle>Kundennummer</span>
        <span matListItemLine>{{ deliveryRecipient().id }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>Name</span>
        <span matListItemLine>{{ deliveryRecipient().name }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>Straße & Hausnummer</span>
        <span matListItemLine>{{ deliveryRecipient().address?.streetAddress }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>PLZ & Ort</span>
        <span matListItemLine>{{ deliveryRecipient().address?.postalCode }} {{ deliveryRecipient().address?.locality }}</span>
      </mat-list-item>
    </mat-list>
  </div>
  <div class="row-item">
    <p class="heading">Rechnungsadresse</p>
    @if (deliveryEqualsRecipientAddressee()) {
      <p class="equal-address">Entspricht der Lieferadresse</p>
    } @else {
      <mat-list>
        <mat-list-item>
          <span matListItemTitle>Kundennummer</span>
          <span matListItemLine>{{ invoiceRecipient().id }}</span>
        </mat-list-item>
        <mat-list-item>
          <span matListItemTitle>Name</span>
          <span matListItemLine>{{ invoiceRecipient().name }}</span>
        </mat-list-item>
        <mat-list-item>
          <span matListItemTitle>Straße & Hausnummer</span>
          <span matListItemLine>{{ invoiceRecipient().address?.streetAddress }}</span>
        </mat-list-item>
        <mat-list-item>
          <span matListItemTitle>PLZ & Ort</span>
          <span matListItemLine>{{ invoiceRecipient().address?.postalCode }} {{ invoiceRecipient().address?.locality }}</span>
        </mat-list-item>
      </mat-list>
    }
  </div>
</div>
